import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
    signal,
    WritableSignal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { CustomIconsEnum } from '../../enums/custom-icons';
import { LocalizationService } from '../../services/localization.service';
import { ClientProgressStepperComponent } from '../client-progress-stepper/client-progress-stepper.component';

// TODO make this component more universal
@Component({
    selector: 'apcam-client-progress-header',
    imports: [
        ClientProgressStepperComponent,
        MatButtonModule,
        MatIconModule,
        TranslatePipe,
    ],
    templateUrl: './client-progress-header.component.html',
    styleUrl: './client-progress-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientProgressHeaderComponent {
    /**
     * Writable signal with value whether to hide stepper
     *
     * @default signal(true)
     */
    @Input()
    hideStepper: WritableSignal<boolean> = signal(true);

    /**
     * Number of steps
     *
     * @default 0
     */
    @Input()
    set stepsCount(value: number) {
        this._stepsCount = value;
        this.getProgressStepperItems();
    }
    get stepsCount(): number {
        return this._stepsCount;
    }
    _stepsCount: number = 0;

    /**
     * Input property representing the step in the client progress.
     *
     * @default 1
     */
    @Input()
    step: WritableSignal<number> = signal(1);

    /**
     * Input property indicating whether the step-back functionality is disabled.
     *
     * @default false
     */
    @Input()
    stepBackDisabled: boolean = false;

    /**
     * Output event emitter triggered when the step-back action is invoked.
     */
    @Output()
    stepBack: EventEmitter<void> = new EventEmitter();

    readonly DEFAULT_LANG = this.localizationService.defaultLanguage;

    items: WritableSignal<MenuItem[]> = signal([]);

    CustomIconsEnum = CustomIconsEnum;

    constructor(private readonly localizationService: LocalizationService) {}

    /**
     * Retrieves the URL of the LitFin home page based on the current language.
     *
     * @returns The URL of the LitFin home page.
     */
    protected getLitFinHomePage(): string {
        const currentLang = this.localizationService.getCurrentLanguage();
        return currentLang === this.DEFAULT_LANG
            ? 'https://litfin.capital'
            : `https://litfin.capital/${currentLang}/`;
    }

    /**
     * Prepare items for progress stepper
     */
    private getProgressStepperItems(): void {
        // For each step, push new item into progress stepper items
        this.items.set(new Array(this.stepsCount).fill({ label: '' }));
    }

    protected onBack(): void {
        this.stepBack.emit();
    }
}
